export class NotificationSettingsDTDs {
  static get Settings(): any {
    return {
      preferences: {
        type: 'ngObject',
        typeDef: 'PreferenceBuilder'
      },
      categories: {
        type: 'object',
        typeDef: {
          description: 'string',
          title: 'string',
          id: 'integer',
          nk: 'string',
          rank: 'integer',
          email_send: 'string',
          push_send: 'string',
          sms_send: 'string',
          preferences: {
            postprocessor: 'side-load-lookup',
            hint: {
              lookupKey: 'preferences'
            },
            type: 'key'
          }
        }
      }
    };
  }

  static get Preference(): any {
    return {
      PUSH: {
        type: 'tri-state',
        defaultValue: undefined
      },
      TEXT: {
        type: 'tri-state',
        defaultValue: undefined
      },
      EMAIL: {
        type: 'tri-state',
        defaultValue: undefined
      }
    };
  }
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-notification-settings/src/constants/notification_settings_dtds.ts